<template>
  <div class="form-tags-parent text-left" :class="{ 'ft-invalidClass': error }">
    <label
      >{{ label }}<span v-show="isMandatory" class="asterik">*</span></label
    >
    <b-skeleton v-if="showLoader" height="38px"></b-skeleton>
    <template v-else>
      <b-form-tags
        :placeholder="placeholder"
        remove-on-delete
        v-model="localValue"
        :disabled="disabled"
        @input="handleInput"
      ></b-form-tags>
      <p v-if="!error" class="ft-grey-txt pt-1 pl-1">
        Press enter to separate tags
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: "FormTags",
  data() {
    return {
      localValue: [],
    };
  },
  watch: {
    // localValue(newValue) {
    //   this.$emit("update-value", newValue);
    // },
    vmodel(newValue) {
      if (Array.isArray(newValue)) {
        this.localValue = newValue;
      }
    },
  },
  created() {
    if (Array.isArray(this.vmodel)) {
      this.localValue = this.vmodel;
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    vmodel: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Enter",
    },
    isMandatory: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Label",
    },
  },
  methods: {
    handleInput() {
      this.$emit("update-value");
      this.$emit("select-value", this.localValue);
    },
  },
};
</script>

<style>
.form-tags-parent .b-form-tags-input {
  padding-bottom: 2px !important;
}
.form-tags-parent .form-control {
  border-radius: 0.5rem;
  background: var(--color-white);
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  font-family: "Lato", sans-serif;
  font-weight: var(--weight-500);
  font-size: 16px;
  color: #565656;
  height: 37px !important;
  overflow-x: auto;
  width: 100%;
  overflow-y: hidden;
}
.form-tags-parent ul {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  width: 100%;
}
.ft-invalidClass .form-control {
  border: 1px solid #eb0002 !important;
}

.form-tags-parent input::placeholder {
  color: var(--input-placeholder);
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-400);
  font-size: var(--size-14);
}

.ft-grey-txt {
  font-family: "Lato", sans-serif;
  font-size: var(--size-10);
  font-weight: var(--weight-500);
  color: var(--light-grey);
}

.form-tags-parent .b-form-tag {
  background-color: var(--primary-blue);
  border-radius: 1.25rem;
  padding-left: 0.125rem 0.625rem;
}

.form-tags-parent .b-form-tag > button.b-form-tag-remove {
  font-size: 101%;
  line-height: 1;
  padding: 0 0.125rem;
  float: none;
  top: 1px;
  margin-left: 0.25rem;
  color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  border-radius: 0.813rem;
  height: 0.813rem;
  /* width: 12px; */
  position: relative;
  opacity: 1;
}
.add-res-tabs .form-tags-parent ul {
  width: 100%;
}

.form-tags-parent .badge-secondary {
  background-color: #f1f7ff;
  border-radius: 0.9375rem;
  padding: 0.125rem 0.375rem;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: var(--size-12);
  color: var(--primary-blue);
}

.form-tags-parent .btn-outline-secondary {
  color: var(--primary-blue);
  border-color: var(--primary-blue);
  border-radius: 20px;
}

.form-tags-parent .btn-outline-secondary:hover {
  background-color: var(--primary-blue);
  color: #ffffff;
}
.form-control:focus {
  box-shadow: none !important;
}
.b-form-tags.focus {
  box-shadow: none !important;
}
.b-form-tags.disabled {
  background-color: #e9ecef !important;
}
</style>
